import React from 'react';
import { Card, CardBody, CardHeader, Heading, Text, VStack } from '@chakra-ui/react';

const rowValue = (value) => value || '—';

const Row = ({ label, value }) => (
  <Text>
    <strong>{label}:</strong> {rowValue(value)}
  </Text>
);

const OrganizationInfoSection = ({ organization }) => (
  <Card>
    <CardHeader pb={2}>
      <Heading size="md">School Information</Heading>
    </CardHeader>
    <CardBody pt={2}>
      <VStack align="start" spacing={2}>
        <Row label="Name" value={organization?.name} />
        <Row label="Contact" value={organization?.contact} />
        <Row label="Title" value={organization?.title} />
        <Row label="Email" value={organization?.email} />
        <Row label="Phone" value={organization?.phone} />
        <Row label="Address" value={organization?.address} />
        <Row label="City" value={organization?.city} />
        <Row label="State" value={organization?.state} />
        <Row label="Zip" value={organization?.zip || organization?.postcode} />
        <Row label="Country" value={organization?.country} />
      </VStack>
    </CardBody>
  </Card>
);

export default OrganizationInfoSection;
